import { CONFIG } from '../../config';
import { getCookies } from '../getCookies';
import { isAnalyticsConsentGranted } from '../googleAnalytics/ga4/ga4State';
import { toOptionalString, withoutUndefined } from './openAiAdsEvents';

export const OPENAI_ADS_OPPREF_COOKIE = '__oppref';
export const OPENAI_ADS_OBREF_COOKIE = '__obref';

export const isOpenAiAdsPixelEnabled = () => CONFIG.OPENAI_ADS_PIXEL_ID !== '';

export type OpenAiAdsOrderAttributes = {
  openai_ads?: { oppref?: string; obref?: string; source_url: string };
};

export const getOpenAiAdsOrderAttributes = (
  cookies: Record<string, string | undefined>,
  enabled: boolean,
  sourceUrl: string
): OpenAiAdsOrderAttributes => {
  if (!enabled) return {};
  return {
    openai_ads: withoutUndefined({
      oppref: toOptionalString(cookies[OPENAI_ADS_OPPREF_COOKIE]),
      obref: toOptionalString(cookies[OPENAI_ADS_OBREF_COOKIE]),
      source_url: sourceUrl
    })
  };
};

export const openAiAdsOrderAttributes = () =>
  getOpenAiAdsOrderAttributes(
    getCookies(),
    isOpenAiAdsPixelEnabled() && isAnalyticsConsentGranted(),
    window.location.href
  );
